var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",staticStyle:{"margin-bottom":"51px !important","overflow":"scroll","margin-top":"-11px"}},[_c('wish')],1)}
var staticRenderFns = []

export { render, staticRenderFns }